import React, { useEffect } from "react";
import ErrorMessage from "../../../../../Shared/error-message/errorMessage";
import Styles from "../../Shared/sharedStyles.module.scss";
import InputField from "../../Shared/inputField/inputField";
import {
  buttonStyles,
  StyledButton,
} from "../../../../../Shared/button/button";
import {
  validBankAccountNumber,
  validIFSCNumber,
} from "../../../../../utils/validation";
import { IdsGenerator } from "../../../../../utils/idGenerator";

function BavMicro({ handleResponse, name }: any) {
  const errorObject = {
    accountNumberError: false,
    ifscNumberError: false,
    consentError: false,
  };

  const [error, setError] = React.useState({ ...errorObject });
  const [isChecked, setIsChecked] = React.useState(false);
  const [isDisabled, setIsDisabled] = React.useState(true);
  const [loading, setLoading] = React.useState(false);

  const accountNumberRef = React.useRef<any>("");
  const ifscNumberRef = React.useRef<any>("");

  function isValid() {
    if (
      accountNumberRef.current.value &&
      ifscNumberRef.current.value &&
      !error.accountNumberError &&
      !error.ifscNumberError
    ) {
      return setIsDisabled(false);
    }

    return setIsDisabled(true);
  }

  useEffect(() => {
    isValid();
  }, [error]);

  function checkAccountNumberValidation() {
    if (
      !validBankAccountNumber(
        accountNumberRef.current.value.trim().toUpperCase()
      )
    ) {
      setError(() => ({
        ...error,
        accountNumberError: true,
      }));
    } else {
      setError(() => ({
        ...error,
        accountNumberError: false,
      }));
    }
  }

  function checkIfscNumberValidation() {
    if (!validIFSCNumber(ifscNumberRef.current.value.trim().toUpperCase())) {
      setError(() => ({
        ...error,
        ifscNumberError: true,
      }));
    } else {
      setError(() => ({
        ...error,
        ifscNumberError: false,
      }));
    }
  }

  function submitVerificationRequest() {
    const accountNumber = accountNumberRef.current.value.toUpperCase();
    const ifscNumber = ifscNumberRef.current.value.toUpperCase();
    const consent = isChecked === true ? "Y" : "N";

    if (!isChecked) {
      setError(() => ({
        ...error,
        consentError: true,
      }));
      return false;
    }
    setLoading(true);
    handleResponse({ accountNumber, ifscNumber, consent }, setLoading);
  }

  return (
    <div className={`${Styles.content}`}>
      <div className={`${Styles.trialText} pl-2`}>Running Trial on</div>
      <div className={`${Styles.headingText} pl-2`}>{name} </div>
      <div className={`${Styles.infoForm} pl-2`}>
        <hr />
        <p className="mt-2">Fill in the below details to run verification</p>
        <div className="d-flex flex-column">
          <div className="d-flex flex-column mb-2">
            <label className={`${Styles.label} flex-grow-1`}>
              Account Number
            </label>
            <InputField
              maxLength={16}
              id={IdsGenerator({
                prefix: "bank account verification micro",
                id: "change",
                suffix: "account number",
              })}
              inputRef={accountNumberRef}
              onChange={checkAccountNumberValidation}
              isError={error.accountNumberError}
              purpose="forBankVerification"
            />
            {error.accountNumberError && (
              <ErrorMessage>Please enter a valid Account number</ErrorMessage>
            )}
          </div>
          <div className="d-flex flex-column mb-3 ">
            <label className={`${Styles.label} flex-grow-1`}>IFSC Number</label>
            <InputField
              id={IdsGenerator({
                prefix: "bank account verification micro",
                id: "change",
                suffix: "ifsc number",
              })}
              onChange={checkIfscNumberValidation}
              maxLength={11}
              inputRef={ifscNumberRef}
              isError={error.ifscNumberError}
              purpose="forBankVerification"
            />
            {error.ifscNumberError && (
              <ErrorMessage>Please enter a valid IFSC number</ErrorMessage>
            )}
          </div>
          <div className="pt-4 pl-4 pb-4 mt-4 d-flex flex-column">
            <div className="d-flex align-items-center py-0 gap-2">
              <input
                id={IdsGenerator({
                  prefix: "bank account verification micro",
                  id: "check",
                  suffix: "consent",
                })}
                data-testid={IdsGenerator({
                  prefix: "bank account verification micro",
                  id: "check",
                  suffix: "consent",
                })}
                type="checkbox"
                className={`${Styles.formCheckInput} `}
                onChange={(e: any) => setIsChecked(e.target.checked)}
              />
              <p className={`${Styles.ackText} mb-0`}>
                I hereby agree, to let zoop.one verify my data for verification
              </p>
            </div>
            {error.consentError && (
              <ErrorMessage>Please provide consent!</ErrorMessage>
            )}
          </div>
          <div className={`${Styles.buttonGroup}`}>
            <StyledButton
              id={IdsGenerator({
                prefix: "bank account verification micro",
                id: "click",
                suffix: "run verification",
              })}
              hoverStyle={{ ...buttonStyles.primary.hover }}
              disabled={isDisabled}
              isLoading={loading}
              style={{ ...buttonStyles.primary.normal }}
              onClick={() => {
                setTimeout(() => setError({ ...errorObject }), 2000);
                submitVerificationRequest();
              }}
            >
              Run Verification
            </StyledButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BavMicro;
